import { Box } from '@material-ui/core';
import { useMemo } from 'react';

import { ProgressBarAndTimeline } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/_shared/components/ConditionsAndProgress/ProgressBarAndTimeline/Progress/ProgressBarAndTimeline';
import { Conditions } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/_shared/components/ConditionsAndProgress/Conditions/Conditions';
import { BnplPaymentMethodDetailEntity } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/_shared/entities/PaymentMethodDetail/BnplPaymentMethodDetailEntity';
import { PaymentIntentAndLenderSelected } from '@/components/modules/CheckoutSession/Detail/CheckoutSessionDetail/PaymentMethods/PaymentMethod/Loan/Bnpl/PaymentIntent/PaymentIntent';
import { CustomPaper } from '@/components/shared/components/CustomPaper';

interface ConditionsAndProgressProps {
  paymentMethodDetailEntity: BnplPaymentMethodDetailEntity;
}

export const ConditionsAndProgress = ({ paymentMethodDetailEntity }: ConditionsAndProgressProps) => {
  const shouldCreatePaymentIntent = useMemo(
    () => paymentMethodDetailEntity.shouldCreatePaymentIntent(),
    [paymentMethodDetailEntity],
  );

  return (
    <CustomPaper
      fill="paper"
      style={{ minWidth: 0, minHeight: '220px', overflow: 'visible', position: 'relative', paddingBottom: 24 }}
    >
      <Box
        mb={shouldCreatePaymentIntent ? 2 : 0}
        style={{
          opacity: shouldCreatePaymentIntent ? '0.6' : '1',
          pointerEvents: shouldCreatePaymentIntent ? 'none' : 'auto',
        }}
      >
        <Box minHeight={94}>
          <Conditions paymentMethodDetailEntity={paymentMethodDetailEntity} />
        </Box>
        {!shouldCreatePaymentIntent && (
          <>
            <Box mt={3} />
            <ProgressBarAndTimeline paymentMethodDetailEntity={paymentMethodDetailEntity} />
          </>
        )}
      </Box>
      {shouldCreatePaymentIntent && (
        <PaymentIntentAndLenderSelected paymentMethodDetailEntity={paymentMethodDetailEntity} />
      )}
    </CustomPaper>
  );
};
